var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCsvFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.998,
    viewBox: "0 0 18 17.998",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-553.589 -305.845)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "csv-file",
    d: "M553.751,315.506a2.786,2.786,0,0,1,2.814-2.99,2.663,2.663,0,0,1,1.631.5,2.246,2.246,0,0,1,.856,1.575h-1.415a1.035,1.035,0,0,0-1.08-.9c-.927,0-1.368.775-1.368,1.814s.529,1.808,1.376,1.808a1.052,1.052,0,0,0,1.112-.951h1.415a2.254,2.254,0,0,1-.688,1.463,2.489,2.489,0,0,1-1.831.647A2.781,2.781,0,0,1,553.751,315.506Z",
    transform: "translate(-0.162 0.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csv-file",
    d: "M559.327,316.545h1.423c.064.576.439.816,1.119.816.465,0,.92-.168.92-.6,0-.456-.464-.551-1.247-.744-.991-.231-2.039-.535-2.039-1.734,0-1.224.991-1.759,2.27-1.759,1.24,0,2.2.56,2.255,1.759h-1.383c-.055-.441-.391-.688-.919-.688-.5,0-.824.216-.824.535,0,.4.44.5,1.295.688,1.064.248,2.024.576,2.024,1.8,0,1.2-1.024,1.862-2.344,1.862C560.358,318.48,559.359,317.808,559.327,316.545Z",
    transform: "translate(-0.163 0.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csv-file",
    d: "M564.191,312.629h1.471l.9,3c.128.431.264,1.007.264,1.007h.016s.143-.584.264-1.007l.886-3h1.432l-1.879,5.715h-1.463Z",
    transform: "translate(-0.164 0.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csv-file",
    d: "M568.257,305.845h-10v4.332h1.11V306.97h7.222v3.937h3.888v11.81H559.368v-1.626h-1.111v2.751h13.332V309.22Zm2.222,3.938H567.7V306.97h.1l2.683,2.716Z",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCsvFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/csv-file.29ea116c6fcd4d3f5878cc4317bce679.svg";